import { lazy } from 'react';

const ProductFeeRule = lazy(() => import('./ProductFeeRule'));

export default ProductFeeRule;
